import {parseChemicalWorld} from './chemical-lab-session';
import {parseMeasurementAnswer,type MeasurementRow} from './resource-measurements';
import {chemicalLaboratoryId} from './chemical-lab-config';

/** The notebook uses the latest saved reading per solution; the lab keeps the full history. */
export function chemicalMeasurementRows(value:string,sourceBlockId:string):MeasurementRow[]{
 const history=parseMeasurementAnswer(parseChemicalWorld(value)?.measurementTable??'').rows;
 const latest=new Map<string,MeasurementRow>();
 for(const row of history){
  if(row.source!=='simulation'||!row.measurement?.solutionId)continue;
  latest.set(row.measurement.solutionId,{
   source:'simulation',sourceBlockId,resourceId:chemicalLaboratoryId,
   measurement:{...row.measurement,measurementId:`${row.sourceBlockId}:${row.measurement.measurementId}`},
  });
 }
 return [...latest.values()];
}

export function mergeChemicalMeasurements(value:string,table:string,sourceBlockId:string):string{
 const answer=parseMeasurementAnswer(table);
 const retained=answer.rows.filter(r=>r.source!=='simulation'||r.sourceBlockId!==sourceBlockId);
 return JSON.stringify({...answer,rows:[...retained,...chemicalMeasurementRows(value,sourceBlockId)]});
}
